/**
 * A polyfill for `requestIdleCallback` a feature that is not supported in Safari.
 * It uses a `setTimeout` with a delay of 1ms as a fallback.
 *
 * This ensures that any library or code relying on `requestIdleCallback`
 * does not crash the application in unsupported browsers.
 */
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };
